import algoliasearch from 'algoliasearch/lite';
import envPublic from '@/config/env.public';

const searchClient = algoliasearch(
  String(envPublic.NEXT_PUBLIC_ALGOLIA_APP_ID),
  String(envPublic.NEXT_PUBLIC_ALGOLIA_APP_SECRET)
);

export default searchClient;
